import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TopicThreadHuntingIcon extends BaseIcon {

    getChildren = () => [
        <g fill={this.getColor() === 'currentColor' ? '#aab4c4;' : this.getColor()}>
            <path
                  d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2ZM7.22,18.77a8.34,8.34,0,1,1,11.62-2l0,0a8.28,8.28,0,0,1-11.53,2Z"/>

            <rect  x="10" y="1" width="4" height="2" rx="1" transform="translate(10 14) rotate(-90)"/>
            <rect x="10" y="21" width="4" height="2" rx="1"
                  transform="translate(-10 34) rotate(-90)"/>
            <path
                  d="M16.63,7.61a9.84,9.84,0,0,0-2.83.67h0a6.67,6.67,0,0,1-1.87,3.64,6.77,6.77,0,0,1-3.63,1.87h0a9.6,9.6,0,0,0-.68,2.84.54.54,0,0,0,.49.59.55.55,0,0,0,.6-.5,8.29,8.29,0,0,1,.37-1.86l.17.18A5.65,5.65,0,0,0,11,16.26a5.62,5.62,0,0,0,.77,3.27.55.55,0,0,0,.75.19.54.54,0,0,0,.19-.75,4.51,4.51,0,0,1-.63-2.37,3.9,3.9,0,0,0,3.52-1,3.89,3.89,0,0,0,1-3.52,4.57,4.57,0,0,1,2.36.63.54.54,0,0,0,.66-.08l.09-.11a.55.55,0,0,0-.19-.75A5.66,5.66,0,0,0,16.28,11a6,6,0,0,0-1.23-1.79l-.18-.17a8.78,8.78,0,0,1,1.85-.36.52.52,0,0,0,.34-.16.57.57,0,0,0,.16-.44A.54.54,0,0,0,16.63,7.61Z"/>
            <path
                  d="M11.13,11.13A5.61,5.61,0,0,0,12,4.27a.54.54,0,0,0-.75-.19.55.55,0,0,0-.19.75,4.53,4.53,0,0,1,.61,2.79,3.61,3.61,0,0,0-4,4,4.51,4.51,0,0,1-2.8-.61.55.55,0,0,0-.75.19.54.54,0,0,0,.19.75A5.61,5.61,0,0,0,11.13,11.13Z"/>
            <rect y="11" width="4" height="2" rx="1" transform="translate(4 24) rotate(-180)"/>
            <rect x="20" y="11" width="4" height="2" rx="1"
                  transform="translate(44 24) rotate(-180)"/>
        </g>
    ]
    getViewBox = () => '0 0 24 24'

}


